import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "Components/_Shared/Buttons/Button";
import { DialogModal } from "Components/_Shared/DialogModal";
import { BlFormInput } from "Forms/Components/BlFormInput";
import { FormCharacterCounter } from "Forms/Components/FormCharacterCounter";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";

type ChangeReasonFormType = {
  reason: string;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
};

const MIN_TEXT_LENGTH = 15;
const MAX_TEXT_LENGTH = 300;

export const QuestionnaireChangeReasonModal = ({ isOpen, onClose, onConfirm }: Props) => {
  const { t } = useResource();
  const r = Resources.Questionnaire.ChangeReasonModal;

  const schema = yup.object({
    reason: yup
      .string()
      .trim()
      .required(t(Resources.Validation.Required))
      .min(MIN_TEXT_LENGTH, t(Resources.Validation.String.Min, { count: MIN_TEXT_LENGTH }))
      .max(MAX_TEXT_LENGTH, t(Resources.Validation.String.Max, { count: MAX_TEXT_LENGTH })),
  });

  const methods = useForm<ChangeReasonFormType>({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: { reason: "" },
  });

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = methods;

  const handleClose = () => {
    reset({ reason: "" });
    onClose();
  };

  const onSubmit = (data: ChangeReasonFormType) => {
    onConfirm(data.reason);
    reset({ reason: "" });
  };

  return (
    <DialogModal
      isOpen={isOpen}
      onClose={handleClose}
      title={t(r.Title)}
      subtitle={t(r.Subtitle)}
      content={
        <FormProvider {...methods}>
          <form>
            <BlFormInput
              control={control}
              name="reason"
              label={t(r.Reason)}
              errors={errors}
              multiline
              rows={4}
              characterCounter={
                <FormCharacterCounter characterLimit={MAX_TEXT_LENGTH} characterMinLength={MIN_TEXT_LENGTH} name="reason" />
              }
            />
          </form>
        </FormProvider>
      }
      primaryAction={<Button onClick={handleSubmit(onSubmit)}>{t(Resources.Common.Continue)}</Button>}
    />
  );
};
